import { IndexedDataBase } from "../idb";
import IndexedDataBaseTable from "../model/idb-tabela.js";
import UsuarioConfig from "../model/usuarioConfig.js"

class UsuariosIDB extends IndexedDataBase {
  constructor() {
    const db_name = "UsuariosIDB";
    const db_version = 1;
    const db_tables = [
      new IndexedDataBaseTable("configuracoes"), 
      new IndexedDataBaseTable("fotos", {
          autoIncrement: false, 
          keyPath: 'id'
      })
    ];
    super(db_name, db_version, db_tables);
  }

  /**
   * Implementação do metodo de inicialização da tabela;
   */
  async init() {
    const start = await this.#start();
  }

  /**
   * Implementação do metodo de upgrade de tabela;
   * V1: Cria objetos no store, Limpa dados existentes, e "inicia" o banco de dados;
   * @param {IDBOpenDBRequest} db - Conexão aberta com o IDB para atualização dos
   * dados;
   * 
   * @NOTA Esse método pode necessitar de evoluções conforme
   * futuras necessidades;
   */
  update(db) {
    this.createUpgradeObjectStore(db);
    const cleared = Promise.all([this.clear('fotos'), this.clear('configuracoes')]).then(() => {
      this.#start();
    }).catch(e => {
      console.warn("IDB: Falha ao atualizar tabela de usuários.", e);
    })
  }

  /**
   * Verifica se o objeto de configurações do DB de Usuários existe,
   * se não cria.
   * @NOTA Pode ser necessário um tratamento mais avançado caso
   * necessário atualizar o objeto no futuro (uma validação se
   * o objeto base tem mais dados que o objeto salvo, talvez.)
   */
  async checkConfiguracoesDoUsuario() {
    const configuracoesUsuario = await this.get('configuracoes', 1);
    if(Array.isArray(configuracoesUsuario) || !!!configuracoesUsuario) {
      const config = new UsuarioConfig();
      config.fotos.dataDeVencimento = await this.checkVencimentoFotos(config);
      this.save('configuracoes', config);
    } else {
      configuracoesUsuario.fotos.dataDeVencimento = await this.checkVencimentoFotos(configuracoesUsuario);
      this.save('configuracoes', configuracoesUsuario);
    }
  }

  /**
   * Verifica a configuração do usuário pela data de validade das fotos,
   * se a data for anterior ao dia atual, apaga os dados do ObjectStore (Tabela)
   * de fotos.
   * @param {Object} configs - Objeto de Configurações do UsuariosIDB
   * @returns {Date} - Se a data de vencimeto das configurações for anterior a
   * data atual, retorna uma nova data de vencimento após limpar os campos;
   * Se a data de vencimennto das configurações for igual ou após a data atual,
   * returna a data de vencimento das configurações;
   */
  async checkVencimentoFotos (configs) {
    const dataDeVencimento = this.generateExpirationDate(7);
    if(Array.isArray(configs) || !!!configs || !!!configs.fotos || !!!configs.fotos.dataDeVencimento) {
      return dataDeVencimento
    }
    const today = new Date();
    if(today > configs.fotos.dataDeVencimento) {
      const cleared = await this.clear('fotos');
      return dataDeVencimento;
    } else {
      return configs.fotos.dataDeVencimento;
    }
  }

  /**
   * Verificações, construções e tratamentos que devem ser executados
   * ao iniciar o banco de dados;
   */
  async #start() {
    const config = await this.checkConfiguracoesDoUsuario();
  }
}

export const usuariosIDB = new UsuariosIDB();